import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const CADASTRAL_ADDRESS_TITLE = {
  [ECadastralFieldsNames.BuildingCadastralNumber]: 'Здание',
  [ECadastralFieldsNames.CadastralNumber]: 'Участок',
};
